<template>
  <div>
      <div v-if="firstTime">
          <lay-out></lay-out>
      </div>
    <router-view></router-view>
  </div>
</template>

<script>
import layOut from "@/layout";
export default {
  name: "basevue",
  data(){
      return{
        
      }
  },
  computed:{
      firstTime:function(){
          return this.$route.query.label 
      }
  },
  components: {
    layOut
  },
  mounted(){
      console.log("dfasdasd")
  }
};
</script>

<style scoped>
</style>
